import React from 'react';
import { MessageCircle, Mail, BookOpen } from 'lucide-react';
import { Button } from '../common/Button';

export interface Consultant {
  id: string;
  name: string;
  specialty: string;
  imageUrl: string;
  rating: number;
  chatPrice: number;
  emailPrice: number;
  studyPrice: number;
  available: boolean;
}

interface ConsultantCardProps {
  consultant: Consultant;
  onSelectService: (consultantId: string, serviceType: 'chat' | 'email' | 'study') => void;
}

export const ConsultantCard: React.FC<ConsultantCardProps> = ({
  consultant,
  onSelectService
}) => {
  return (
    <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6 flex flex-col">
      <div className="flex items-center space-x-4 mb-4">
        <div className="relative">
          {consultant.imageUrl ? (
            <img
              src={consultant.imageUrl}
              alt={consultant.name}
              className="w-20 h-20 rounded-full object-cover"
            />
          ) : (
            <div className="w-20 h-20 rounded-full bg-purple-500/30 flex items-center justify-center text-2xl text-purple-200">
              {consultant.name.charAt(0).toUpperCase()}
            </div>
          )}
          {consultant.available && (
            <div className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 rounded-full border-2 border-indigo-950" />
          )}
        </div>
        <div>
          <h3 className="text-lg font-medium text-purple-200">{consultant.name}</h3>
          <p className="text-purple-200/70 text-sm">{consultant.specialty}</p>
          <div className="flex items-center mt-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <span
                key={i}
                className={`text-sm ${
                  i < consultant.rating ? 'text-yellow-400' : 'text-purple-200/30'
                }`}
              >
                ★
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="space-y-3 mt-auto">
        <Button
          onClick={() => onSelectService(consultant.id, 'chat')}
          variant="outline"
          className="w-full justify-between"
          icon={<MessageCircle className="w-4 h-4" />}
          disabled={!consultant.available}
        >
          <span>Tarifa: {consultant.chatPrice} créditos/min</span>
        </Button>

        <Button
          onClick={() => onSelectService(consultant.id, 'email')}
          variant="outline"
          className="w-full justify-between"
          icon={<Mail className="w-4 h-4" />}
        >
          <span>Consulta por email</span>
          <span className="text-purple-300">{consultant.emailPrice} créditos</span>
        </Button>

        <Button
          onClick={() => onSelectService(consultant.id, 'study')}
          variant="outline"
          className="w-full justify-between"
          icon={<BookOpen className="w-4 h-4" />}
        >
          <span>Estudo completo</span>
          <span className="text-purple-300">{consultant.studyPrice} créditos</span>
        </Button>
      </div>
    </div>
  );
};